var OpenPaymentsDataTestIdEnum = /* @__PURE__ */ ((OpenPaymentsDataTestIdEnum2) => {
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_HEADER_BUTTON"] = "open-payments--header-button";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_HEADER_BADGE"] = "open-payments--header-badge";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_NOTICE"] = "open-payments--notice";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_NOTICE_LINK"] = "open-payments--notice-link";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_NOTICE_DISMISS_BUTTON"] = "open-payments--notice-dismiss-button";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_PAGE_TITLE"] = "open-payments--page-title";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_LIST"] = "open-payments--list";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_SKELETON"] = "open-payments--skeleton";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_CARD"] = "open-payments--card";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_CARD_PROCEDURES"] = "open-payments--card-procedures";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_CARD_PATIENT"] = "open-payments--card-patient";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_CARD_SUMMARY"] = "open-payments--card-summary";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_CARD_CANCEL_BUTTON"] = "open-payments--card-cancel-button";
  OpenPaymentsDataTestIdEnum2["OPEN_PAYMENTS_CARD_PAY_BUTTON"] = "open-payments--card-pay-button";
  return OpenPaymentsDataTestIdEnum2;
})(OpenPaymentsDataTestIdEnum || {});
export {
  OpenPaymentsDataTestIdEnum
};
